import React from 'react';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';

const teamMembers = [
  { id: 1, name: 'Anna Müller', role: 'Gründerin & Meisterkonditorin', bio: 'Anna hat über 15 Jahre Erfahrung in der Patisserie und leitet unser Kreativteam. Ihre Passion ist die perfekte Kombination von Textur und Geschmack.' },
  { id: 2, name: 'Clara Schmidt', role: 'Chocolatière', bio: 'Clara ist unsere Spezialistin für Schokolade. Sie verfeinert jede Trüffel mit höchster Präzision und einem Gespür für Details.' },
  { id: 3, name: 'Jonas Weber', role: 'Leiter Produktion', bio: 'Jonas sorgt dafür, dass unsere Manufaktur reibungslos läuft. Er kombiniert Effizienz mit dem Anspruch höchster Qualität.' },
  { id: 4, name: 'Lisa Hoffmann', role: 'Verpackungsdesignerin', bio: 'Lisa gestaltet unsere stilvollen Verpackungen und sorgt dafür, dass jedes Produkt nicht nur schmeckt, sondern auch schön ist.' },
  { id: 5, name: 'Markus Wagner', role: 'Kundenbetreuung & Logistik', bio: 'Markus kümmert sich um den Versand und die Kundenbetreuung. Er stellt sicher, dass jede Bestellung pünktlich und in perfektem Zustand ankommt.' }
];

export default function About() {
  return (
    <div>
      <Helmet>
        <title>Über uns - Novurem Patisserie</title>
        <meta name="description" content="Lernen Sie das Team von Novurem Patisserie kennen. Meisterkonditoren und Chocolatiers aus Ettlingen - mit Leidenschaft für feine Confiserie." />
      </Helmet>

      <section className="page-header">
        <div className="container">
          <h1>Über Novurem Patisserie</h1>
          <p>Unsere Geschichte, unser Handwerk, unsere Leidenschaft.</p>
        </div>
      </section>

      <section className="about-section">
        <div className="container">
          <h2>Unsere Geschichte</h2>
          <div className="about-text">
            <p>
              Novurem Patisserie wurde im Jahr 2009 in Ettlingen gegründet. Wir begannen mit
              einer kleinen Werkstatt und einer großen Vision: die feinste Confiserie
              Deutschlands zu schaffen. Heute sind wir ein Team von leidenschaftlichen
              Konditoren und Chocolatiers, die täglich daran arbeiten, außergewöhnliche
              Geschmackserlebnisse zu kreieren.
            </p>
            <p>
              Unsere Philosophie ist einfach: Nutze nur die besten Zutaten, respektiere die
              Tradition und denke innovativ. Diese Prinzipien spiegeln sich in jedem Produkt
              wider, das unsere Manufaktur verlässt. Ob Klassiker wie die Schwarzwälder
              Kirschtorte oder moderne Kreationen wie unsere Pistazien-Trüffel – wir streben
              bei allem die Perfektion an.
            </p>
            <p>
              Qualität ist für uns nicht verhandelbar. Wir beziehen unsere Zutaten von
              ausgewählten Partnern, die nachhaltige Landwirtschaft betreiben. Unsere
              Schokolade kommt aus Ecuador, unsere Pistazien aus Sizilien und die Vanille
              aus Madagaskar. Die Produktion erfolgt in kleinen Chargen, um maximale
              Frische und Geschmackstiefe zu gewährleisten.
            </p>
            <p>
              Mit über 25 Produkten im Sortiment und mehr als 1500 zufriedenen Kunden sind
              wir stolz auf das, was wir erreicht haben. Die Novurem Manufaktur ist mehr als
              ein Geschäft – es ist ein Ort der Kreativität und der Handwerkskunst. Wir
              freuen uns darauf, Sie bald bei uns begrüßen zu dürfen.
            </p>
          </div>
          <h2 style={{ textAlign: 'center', fontSize: '30px', marginTop: '50px' }}>Unser Team</h2>
          <div className="team-section">
            {teamMembers.map((member, index) => (
              <div className="team-card" key={member.id}>
                <img src={`/images/team_${member.id}.jpg`} width="400" height="400" alt={`Team Mitglied ${member.name}`} />
                <h3>{member.name}</h3>
                <p><strong>{member.role}</strong></p>
                <p>{member.bio}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>Kontaktieren Sie unser Team</h2>
            <p>Haben Sie Fragen oder spezielle Wünsche? Wir sind für Sie da.</p>
            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <FaPhone /> +4977081869489
              <a href="mailto:novurem@hotmail.com" className="btn btn-secondary"><FaEnvelope /> info@novurem.com</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}